<template>
  <div>
    <Header />
    <main class="app-content">
      <div class="app-title">
        <div>
          <h1><i class="fa fa-dashboard"></i>PERSONEL BAKİYE EKRANI</h1>
        </div>
        <ul class="app-breadcrumb breadcrumb">
          <li class="breadcrumb-item"><i class="fa fa-home fa-lg"></i></li>
          <li class="breadcrumb-item">
            <a href="#">PERSONEL BAKİYE EKRANI</a>
          </li>
        </ul>
      </div>
      <div class="row form-margin">
        <div class="col-md-12 tex-center d-flex align-items-center flex-column">
          <div class="tile">
            <h3 class="tile-title">PERSONEL BAKİYE EKRANI</h3>

            <div class="tile-body">
              <form>
                <div id="app">
                  <label class="control-label"
                    >Personel Seçiniz</label
                  >
                  <select class="form-control" @change="getBySaha($event)">
                    <option value="" selected disabled>PERSONEL SEÇİNİZ</option>
                    <option
                      v-for="personel in personeller"
                      :value="personel.id"
                      :key="personel.id"
                      >{{ personel.name +" " + personel.surname}}</option
                    >
                  </select>
                </div>

                <!-- <div class="form-group">
                  <label class="control-label">Toplam Delgi Sayısı</label>
                  <input
                    v-model="toplam_delgi"
                    class="form-control"
                    type="text"
                    placeholder="Toplam Delgi Sayısı"
                  />
                </div> -->
                <!-- <div class="form-group">
                  <label class="control-label">Delgi Çapı</label>
                  <input
                    v-model="cap_delgi"
                    class="form-control"
                    type="text"
                    placeholder="Delgi Çapı"
                  />
                </div> -->
                <!-- <div class="form-group">
                  <label class="control-label">Derinlik</label>
                  <input
                    v-model="derinlik"
                    class="form-control"
                    type="number"
                    placeholder="Derinlik"
                  />
                </div> -->
                <!-- <div class="form-group">
                  <label class="control-label">Delgi Birim Fiyatı</label>
                  <input
                    v-model="fiyat_delgi"
                    class="form-control"
                    type="text"
                    placeholder="Delgi Birim Fiyatı"
                  />
                </div> -->
              </form>
            </div>

            <!-- <div class="tile-footer">
              <button @click="sendData()" class="btn btn-primary" type="button">
                <i class="fa fa-fw fa-lg fa-check-circle"></i>Güncelle
              </button>
            </div> -->
          </div>
          
      <div class="row">
        <div class="col-md-12">
          <div class="tile">
            <div class="tile-body">
              <table class="table table-hover table-bordered" id="sampleTable">
                <thead>
                  <tr>
                    <th>Id</th>
                    <th>Saha Adı</th>
                    <th>Makina Adı</th>
                    <th>Tutar</th>
                    <th>Açıklama 1</th>
                    <th>Açıklama 2</th>
                    <th>Toplam Bakiye</th>
                    <th>Date</th>
                  </tr>
                </thead>
                <tbody></tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
        </div>
      </div>
    </main>

    <Sidebar />
  </div>
</template>

<script>
import Header from "./default/Header";
import Sidebar from "./default/Sidebar";
import axios from "axios";
import store from "../store";
import PersonelEkle from "./PersonelEkle.vue";
export default {
  data() {
    return {
      sahaname: "",
      personeller: [],
      cap_delgi: "",
      derinlik: "",
      fiyat_delgi: "",
      toplam_delgi: "",
      personelId: "",
    };
  },
  mounted() {
    window.scrollTo(0, 0);
    var token = localStorage.getItem("token");
    if (!token) {
      this.$router.push("/");
    }
    var url = store.state.base_url + "AslanSahalar/getAllPersonel.php?key=123";
    axios
      .post(url)
      .then((response) => {
        this.personeller = response.data;
      //  console.log(personeller);
      })
      .catch((err) => {
        console.log(err.response);
      });
  },
  methods: {
    getBySaha(event) {
      var personelId = event.target.value;
      this.personelId = personelId;
      var url = store.state.base_url + "AslanSahalar/getByBakiye.php?key=123";
      var datas = {
          id: localStorage.getItem("id"),
          token: localStorage.getItem("token"),
          personelId: this.personelId,
        };
        axios
      .post(url, JSON.stringify(datas))
      .then((response) => {
        datas = "";
        datas = response.data;
        console.log(datas);
        var table = $("#sampleTable").DataTable();
        table.clear();
        $.each(datas, function(index, value) {
          table.row
            .add([
              value["id"],
              value["sahaId"],
              value["makina_id"],
              value["tutar"] + "₺",
              value["aciklamaone"],
              value["aciklamatwo"],
              value["toplambakiye"]+ "₺",
              value["date"],

            ])
            .draw(false);
        });

        $("#sampleTable tbody").on("click", "tr", function() {
          var data = table.row(this).data();
          results.id = data[0];
          window.location.href = "#/updatedelgi?id=" + results.id;
        });
      })
      .catch((err) => {
        //console.log(err.response);
      });
    },
    reload: function() {
      location.reload();
    },
    sendData: function() {
      console.log(this.oprone);
      if (this.cap_delgi == "") {
        this.$swal({
          text: "DELGİ ÇAPINI GİRİNİZ!",
          icon: "error",
          closeOnClickOutside: false,
        });
      } else if (this.derinlik == "") {
        this.$swal({
          text: "DELGİ DERİNLİĞİNİ GİRİNİZ!",
          icon: "error",
          closeOnClickOutside: false,
        });
      }  else if (this.fiyat_delgi == "") {
        this.$swal({
          text: "DELGİ BİRİM FİYATINI GİRİNİZ!",
          icon: "error",
          closeOnClickOutside: false,
        });
      } else if (this.toplam_delgi == "") {
        this.$swal({
          text: "TOPLAM DELGİ SAYISINI GİRİNİZ!",
          icon: "error",
          closeOnClickOutside: false,
        });
      }else {
        var url = store.state.base_url + "AslanSahalar/updateSahaData.php?key=123";
        var datas = {
          id: localStorage.getItem("id"),
          token: localStorage.getItem("token"),
          cap_delgi: this.cap_delgi,
          derinlik: this.derinlik,
          fiyat_delgi: this.fiyat_delgi,
          toplam_delgi: this.toplam_delgi,
          saha_id: this.saha_id
        };

        axios
          .post(url, JSON.stringify(datas))
          .then((response) => {
            if (response.data == true) {
              this.$swal({
                text: "Güncelleme İşleminiz Başarıyla Gerçekleştirildi!",
                icon: "success",
                closeOnClickOutside: true,
              });
              setTimeout(function() {
                location.reload();
              }, 1250);
            } else {
              this.$swal({
                text: "Hata Oluştu Admine Danışın!",
                icon: "error",
                closeOnClickOutside: false,
              });
            }

            ////conso.log(response);
          })
          .catch((error) => {
            //conso.log(error.response);
          });
      }
    },
  },

  components: {
    Header,
    Sidebar,
  },
};
</script>



// WEBPACK FOOTER //
// src/components/PersonelBakiye.vue